const getDefaultState = () => {
  return {
    bookList: [],
    instrumentList: {},
    accountList: {},
    bookSetList: [],
    bookAssetList: []
  }
}

// const state = getDefaultState()

const module = {
  namespaced: true,
  state: {
    bookList: [],
    instrumentList: {},
    accountList: {},
    bookSetList: [],
    bookAssetList: []
  },
  getters: {
    getBookList: state => state.bookList,
    getInstrumentList: state => state.instrumentList,
    getAccountList: state => state.accountList,
    getBookSetList: state => state.bookSetList,
    getBookAssetList: state => state.bookAssetList
  },
  mutations: {
    DELETE_BOOKLIST (state) {
      state.bookList = []
    },
    SET_BOOKLIST: (state, bookList) => {
      state.bookList = bookList
    },
    DELETE_INSTRUMENTLIST (state) {
      state.instrumentList = {}
    },
    ADD_INSTRUMENTLIST: (state, data) => {
      Object.assign(state.instrumentList, data)
    },
    DELETE_ACCOUNTLIST (state) {
      state.accountList = {}
    },
    ADD_ACCOUNTLIST: (state, data) => {
      Object.assign(state.accountList, data)
    },
    SET_BOOKSETLIST: (state, bookSetList) => {
      state.bookSetList = bookSetList
    },
    SET_BOOKASSETLIST: (state, bookAssetList) => {
      state.bookAssetList = bookAssetList
    },
    RESET_STORE: (state) => {
      Object.assign(state, getDefaultState())
    }
  },
  actions: {
    deleteBookList ({commit}) {
      commit('DELETE_BOOKLIST')
    },
    setBookList({ commit }, data) {
      commit('SET_BOOKLIST', data)
    },
    deleteInstrumentList ({commit}) {
      commit('DELETE_INSTRUMENTLIST')
    },
    addInstrumentList({ commit }, data) {
      commit('ADD_INSTRUMENTLIST', data)
    },
    deleteAccountList ({commit}) {
      commit('DELETE_ACCOUNTLIST')
    },
    addAccountList({ commit }, data) {
      commit('ADD_ACCOUNTLIST', data)
    },
    setBookSetList({ commit }, data) {
      commit('SET_BOOKSETLIST', data)
    },
    setBookAssetList({ commit }, data) {
      commit('SET_BOOKASSETLIST', data)
    }
  }
}

export default module
